module.exports = __webpack_public_path__ + "static/media/29EUNOG9.6c5f1adc.jpg";